<!-- app.component.html -->
<div class="relative min-h-screen pb-[60px] pt-[60px]">
<app-header></app-header>
  
  <!-- Main Content -->
  <main class="main-content">
    <router-outlet></router-outlet>
  </main>
  
  <!-- Footer -->
  <footer class="absolute bottom-0 w-full bg-gray-100 py-4 border-t border-gray-200">
    <div class="text-center text-gray-600 text-sm">
      <p dir="rtl">© {{ currentYear }} כל הזכויות שמורות לי.מ</p>
    </div>
  </footer>
</div>

<!-- Overlay for closing menu when clicking outside -->
<div *ngIf="(isMenuOpen$ | async)" 
     class="fixed inset-0 bg-transparent z-10"
     (click)="toggleMenu()">
</div>